import * as Actions from '../../actions/customerCommunication/type';

const initialState = {
  getCustomerCommLoading: false,
  getCustomerCommunication: [],
  getCustomerCommErr: '',

  sendSmsOrEmailToCusLoading: false,
  sendSmsOrEmailToCusMsg: '',
  sendSmsOrEmailToCusMsgErr: '',
};
const customerCommunication = (state = initialState, action) => {
  switch (action.type) {
    // Get Customer Messages

    case Actions.GET_CUSTOMER_COMMUNICATION_REQUEST:
      return {
        ...state,
        getCustomerCommLoading: true,
        getCustomerCommunication: [],
      };
    case Actions.GET_CUSTOMER_COMMUNICATION_SUCCESS:
      return {
        ...state,
        getCustomerCommLoading: false,
        getCustomerCommunication: action?.payload?.data || [],
      };
    case Actions.GET_CUSTOMER_COMMUNICATION_FAIL:
      return {
        ...state,
        getCustomerCommLoading: false,
        getCustomerCommErr: action.payload,
      };

    // Send SMS Or Email To Customer

    case Actions.SEND_SMS_OR_EMAIL_TO_CUSTOMER_REQUEST:
      return {
        ...state,
        sendSmsOrEmailToCusLoading: true,
        sendSmsOrEmailToCusMsg: '',
      };
    case Actions.SEND_SMS_OR_EMAIL_TO_CUSTOMER_SUCCESS:
      return {
        ...state,
        sendSmsOrEmailToCusLoading: false,
        sendSmsOrEmailToCusMsg: action?.payload?.data || '',
      };
    case Actions.SEND_SMS_OR_EMAIL_TO_CUSTOMER_FAIL:
      return {
        ...state,
        sendSmsOrEmailToCusLoading: false,
        sendSmsOrEmailToCusMsgErr: action.payload,
      };

    case Actions.CLEAR_CUSTOMER_COMMUNICATION_STATES:
      return {
        ...state,
        getCustomerCommLoading: false,
        getCustomerCommErr: '',

        sendSmsOrEmailToCusLoading: false,
        sendSmsOrEmailToCusMsg: '',
        sendSmsOrEmailToCusMsgErr: '',
      };

    default:
      return state;
  }
};
export default customerCommunication;
